<template>
  <div class="advantage-main">
    <div class="advantage-one" v-for="url in urls" :key="url.id">
      <van-image
        :src="url"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      urls: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part2-1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part2-2.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part2-3.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part2-4.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part2-5.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking1/part2-6.jpg"
      ]
    };
  }
};
</script>

<style scoped>
.advantage-main{
  width: 100%;
  display: flex;
  justify-content:space-between;
  flex-wrap: wrap;

}
.advantage-one {
  width: 32.66%;
}
</style>

